import { render } from "./UserCard.vue?vue&type=template&id=d3ae7968&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=d3ae7968&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d3ae7968"

export default script